import DefinitionTypes from "../definition-types";

interface DiscoveryChallenge {
  definition?: {
    status?: string;
  };
  selectedByDefault?: boolean;
}

interface IsCustomChallengeParams {
  discoveryChallenge: DiscoveryChallenge;
}

export const isCustomChallenge = ({
  discoveryChallenge
}: IsCustomChallengeParams): boolean => {
  return discoveryChallenge?.definition?.status === DefinitionTypes.NEW;
};

export const isTypicalChallenge = (
  discoveryChallenge: DiscoveryChallenge
): boolean => {
  return discoveryChallenge?.selectedByDefault ?? false;
};
